import React, {useEffect, useState} from 'react';
import {FileCopyOutlined} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from 'prop-types';
import {copyToClipboard} from '../helpers/copyToClipboard';

const CopyItem = (props) => {
  const [copied, setCopied] = useState(false);
  useEffect(()=>{
    const timer = setTimeout(()=>{
      setCopied(false)
    }, 1000);
    return () => clearTimeout(timer);
  },[copied]);

  return (<>
    <Tooltip open={copied} title={'Copied!'}  >
      <FileCopyOutlined fontSize="small" sx={{ color: 'text.secondary', ml: 0.5 }} onClick={async () => {
        await copyToClipboard(props?.thingToCopy);
        setCopied(true);
      }} />
    </Tooltip>
    </>)
};

CopyItem.propTypes = {
  thingToCopy: PropTypes.string.isRequired
};

export default CopyItem;